
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/flamingo/functions",
      function () {
        return require("private-next-pages/products/flamingo/functions.tsx");
      }
    ]);
  